import { applyMiddleware, createStore } from 'redux';
import { authMiddleware } from '@middlewares/auth-middleware';
import rootReducer from '../reducers/index';
import { composeWithDevTools } from 'redux-devtools-extension';

import { userMiddleware } from '@middlewares/user-middleware';

import { institutionTableMiddleware } from '@middlewares/institution-table/institution-table-middleware';

const middleware = applyMiddleware(
  authMiddleware,
  userMiddleware,
  institutionTableMiddleware,
);

function configureStore(initialState?: ReturnType<typeof rootReducer>) {
  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(middleware),
  );

  return store;
}

export default configureStore;
